export default {
    configuration: false,
    transferTables: true,
    popPrefix: '/api-mdm/dictionaryDetail/dict',
    searchList: {
        searchTxt: [
            {
                name: '创建时间',
                value: 'createTime',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                type: 'time',
                unfold: true,
                timeNum: 3,
                span: 4
            },
            {
                name: '客户订单号',
                value: 'custOrderNoList',
                type: 'input',
                unfold: true,
                batch: true,
                span: 4
            },
            {
                name: '运输单状态',
                value: 'taskStatusList',
                filterable: true,
                type: 'select',
                multiple: true,
                unfold: true,
                data: ['0'],
                optionNum: 'MAP_TRANSPORT_STATUS',
                span: 4,
                options: []
            },
            {
                name: '服务平台',
                value: 'siteNameList',
                unfold: true,
                multiple: true,
                maxSelect: 5,
                border: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn', value: '服务平台名称'
                },
                span: 3,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '平台名称' },
                    { prop: 'escoCompanyNo', value: '平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '平台名称' },
                    { prop: 'escoCompanyNo', value: '平台编码' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: [
                    'escoCompanyNo#siteCodeList',
                    'escoCompanyNameCn#siteNameList'
                ]
            },
            {
                name: '客户',
                value: 'customerNameList',
                unfold: true,
                multiple: true,
                border: true,
                maxSelect: 5,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'ebcuNameCn', value: '客户名称'
                },
                span: 3,
                type: 'advance',
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                    // { prop: 'businessAddress', value: '客户地址' } 2期不展示
                ],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                cbParams: ['pmCode#customerCodeList', 'ebcuNameCn#customerNameList']
            },
            {
                name: '仓库',
                value: 'cdwhName',
                type: 'advance',
                span: 3,
                unfold: true,
                multiple: true,
                border: true,
                maxSelect: 5,
                dialogWidth: '1000px',
                multipleTableColumn: {
                    prop: 'cdwhName', value: '仓库名称'
                },
                advanceConfig: [
                    { prop: 'cdwhName', value: '仓库名称' },
                    { prop: 'whCode', value: '仓库编码' }
                ],
                tableConfig: [
                    { prop: 'whCode', value: '仓库编码' },
                    { prop: 'cdwhName', value: '仓库名称' },
                    { prop: 'eblcLatitude', value: '经度地址' },
                    { prop: 'eblcLongitude', value: '维度地址' }
                ],
                advanceUrl: 'cdWarehouse/search',
                cbParams: [
                    'whCode', 'cdwhName', 'eblcDetailAddress', 'eblcLongitude#cdwhLongitude', 'eblcLatitude#cdwhLatitude'
                ]
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    pickerConfig: {
        shortcuts: []
    },
    table: {
        height: '140px',
        leftOperation: false,
        // 列配置页面 地图点显示
        columns: [
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: '180px'
            },
            {
                label: '包装数',
                prop: 'totalPackageQuantity',
                width: '120px'
            },
            {
                label: '件数',
                prop: 'totalQty',
                width: '160px'
            },
            {
                label: '重量',
                prop: 'totalGrossWeight',
                width: '160px'
            },
            {
                label: '体积',
                prop: 'totalVolume',
                width: '160px'
            },
            {
                label: '客户名称',
                prop: 'customerName',
                width: '180px'
            },
            {
                label: '收货详细地址',
                prop: 'receiverDetailAddr',
                width: '180px'
            },
            {
                label: '收货人',
                prop: 'receiverName',
                width: '160px'
            },
            {
                label: '收货人联系方式',
                prop: 'receiverMobile',
                width: '160px'
            },
            {
                label: '备注',
                prop: 'remark',
                width: '160px'
            },
        ],
        // 高级搜索
        searchTotalTitle: [
            {
                name: '发货省/市/区县/乡镇',
                value: 'senderAddressSelectCode',
                type: 'addressSelect',
                config: {
                    multiple: true,
                    checkStrictly: true
                }
            },
            {
                name: '收货省/市/区县/乡镇',
                value: 'receiverAddressSelectCode',
                type: 'addressSelect',
                unfold: true,
                config: {
                    multiple: true,
                    checkStrictly: true
                }
            },
            {
                name: '订单类型',
                value: 'orderTypeList',
                type: 'select',
                filterable: true,
                multiple: true,
                optionNum: 'ORDER_TYPE_NEW',
                options: []
            },
            // 收货人信息
            {
                'name': '收货人手机号',
                'value': 'receiverMobile',
                'placeholder': '收货人手机',
                'type': 'input'
            },
            {
                'name': '发货人手机',
                'value': 'senderMobile',
                'type': 'input'
            },
            {
                'name': '发货人详细地址',
                'value': 'senderDetailAddr',
                'type': 'input'
            },
      {
        "name": "合单码是否为空",
        "value": "emptyConsolidationOrderNo",
        "type": "select",
        "optionNum": "COMBINE_CODE",
        "options": []
      },
      {
        "name": "线路",
        "value": "lineName",
        "type": "advance",
        "advanceConfig": [
            { "prop": "lineMergeName", "value": "线路名称" },
            { "prop": "lineMergeId", "value": "线路编码" }
        ],
        "tableConfig": [
            { "prop": "lineMergeName", "value": "线路名称" },
            { "prop": "lineMergeId", "value": "线路编码" }
        ],
        "method": "post",
        "prefix": "/api-opms",
        "advanceUrl": "/opms/searchMergeLine",
        "cbParams": ["lineMergeName#lineName", "lineMergeId#lineCode"],
        "advanceNotSearch": true,
        "paramType": true
     },
      {
        "name": "运输单号",
        "value": "taskNo",
        "type": "input"
      },
      {
        "name": "要求发车时间",
        "value": "departureTime",
        "type": "time"
      },
      {
        "name": "要求抵达时间",
        "value": "requireArriveTime",
        "type": "time"
      },
      {
        "name": "集拼单号",
        "value": "consolidationOrderNo",
        "type": "input"
      },
      {
        "name": "物流订单号",
        "value": "orderNo",
        "type": "input"
      },
      {
        "name": "来源系统",
        "value": "sourceSystem",
        "type": "select",
        "optionNum": "SOURCE_SYSTEM",
        "options": []
      },
      {
        "name": "原始订单号",
        "value": "originOrderNo",
        "type": "input"
      },
      {
        "name": "源发车单号",
        "value": "sourceDispatch",
        "type": "input"
      },
      {
        "name": "是否分拨订单",
        "value": "distributionFlag",
        "type": "select",
        "options": [
          { "value": "Y", "label": "是" },
          { "value": "N", "label": "否" }
        ]
      },
      {
        "name": "是否继续分拨",
        "value": "distributionContinueFlag",
        "type": "select",
        "options": [
          { "value": "Y", "label": "是" },
          { "value": "N", "label": "否" }
        ]
      },
      {
        "name": "是否模糊订单",
        "value": "planOrderFlag",
        "type": "select",
        "options": [
          { "value": "1", "label": "是" },
          { "value": "0", "label": "否" }
        ]
      },
      {
        "name": "项目分类",
        "value": "projectClassify",
        "type": "select",
        "filterable": true,
        "optionNum": "PROJECT_CLASSIFY",
        "options": []
      },
      {
        "name": "库区",
        "value": "zoneNamesStr",
        "batch": true,
        "type": "input"
      },
      {
        "name": "网点编码",
        "value": "networkCode",
        "type": "input"
      },
      {
        "name": "网点名称",
        "value": "networkName",
        "type": "input"
      },
      {
        "name": "预配载",
        "value": "cnDispatch",
        "type": "select",
        "optionNum": "YES_OR_NO",
        "options": []
      },
      {
        "name": "收货仓编码",
        "value": "upperReceiverCode",
        "type": "input"
      },
      {
        "name": "收货仓名称",
        "value": "upperReceiverName",
        "type": "input"
      },
      {
        "name": "任务类型",
        "value": "taskTypes",
        "type": "select",
        "filterable": true,
        "multiple": true,
        "optionNum": "TASK_TYPE",
        "options": []
      },
      {
        "name": "服务类型",
        "value": "serviceTypeList",
        "type": "select",
        "filterable": true,
        "multiple": true,
        "optionNum": "ORDER_SERVICE_TYPE",
        "options": []
      },
      {
        "name": "业务模式",
        "value": "businessMode",
        "type": "select",
        "optionNum": "BUSINESS_MODE",
        "options": []
      },
      {
        "name": "是否下发",
        "value": "carrierVisibleFlag",
        "type": "select",
        "options": [
          { "value": "Y", "label": "是" },
          { "value": "N", "label": "否" }
        ]
      },
      {
        "name": "计费标准",
        "value": "freightBasisList",
        "optionNum": "SYS_OTP_FREIGHT_BASIS",
        "type": "select",
        "filterable": true,
        "multiple": true,
        "options": []
      },
      {
        "name": "是否预约",
        "value": "appointmentFlag",
        "type": "select",
        "options": [
          { "value": "1", "label": "是" },
          { "value": "0", "label": "否" }
        ]
      },
      {
        "name": "是否精准配送",
        "value": "isJzp",
        "type": "select",
        "options": [
          { "value": "Y", "label": "是" },
          { "value": "N", "label": "否" }
        ]
      },
      {
        "name": "上游集拼单号",
        "value": "consolidationOrderNo",
        "type": "input"
      },
      {
        "name": "合单码",
        "value": "consolidationOrderNo",
        "type": "input"
      },
      {
        "name": "WMS状态",
        "value": "wmsStatus",
        "type": "select",
        "optionNum": "WMS_STATUS",
        "options": []
      },
      {
        "name": "是否仓配分离",
        "value": "logisticMode",
        "type": "select",
        "options": [
          { "value": "WT", "label": "是" },
          { "value": "TW", "label": "否" }
        ]
      },
      {
        "name": "波次号",
        "value": "waveId",
        "batch": true,
        "type": "input"
      },
      {
        "name": "标准收货人",
        "value": "standardReceiverName",
        "type": "advance",
        "advanceConfig": [
          { "prop": "csName", "value": "标准收货人名称" },
          { "prop": "csCode", "value": "标准收货人编码" }
        ],
        "tableConfig": [
            { "prop": "csName", "value": "标准收货人名称" },
          { "prop": "csCode", "value": "标准收货人编码" }
        ],
        "prefix": "/api-dc",
        "advanceUrl": "/standardConsigneeShipper?enableFlag=1",
        "cbParams": ["csCode#standardReceiverCode", "csName#standardReceiverName"]
      },
      {
        "name": "配送方式",
        "value": "deliveryType",
        "optionNum": "DELIVERY_TYPE",
        "type": "select"
      },
      {
        "name": "预约操作人",
        "value": "appointmentOperator",
        "type": "input"
      },
      {
        "name": "预约标识",
        "value": "appointmentMark",
        "type": "select",
        "options": [
          { "value": "1", "label": "未分配未预约" },
          { "value": "2", "label": "已分配未预约" },
          { "value": "3", "label": "已预约" },
          { "value": "4", "label": "无需预约" }
        ]
      },
        ]
    }
};
